import { Component} from '@angular/core';
import { NgxHttpLoaderService, NgxLoader }from 'ngx-http-loader';
import { ThemeVariables, ThemeRef, lyl, StyleRenderer } from '@alyle/ui';

const STYLES = (theme: ThemeVariables, ref: ThemeRef) => {
  const __ = ref.selectorsOf(STYLES);
  return {
    $global: lyl `{
      body {
        background-color: ${theme.background.default}
        color: ${theme.text.default}
        font-family: ${theme.typography.fontFamily}
        margin: 0
        direction: ${theme.direction}
      }
    }`,
    root: lyl `{
      display: block
    }`
  };
};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [StyleRenderer]
})
export class AppComponent  {
  readonly classes = this.sRenderer.renderSheet(STYLES, true);

  title = 'swift-chat-ui';
  public loader = NgxLoader;
  public filterUrls = [
    'https://api.postalpincode.in/pincode/'
];
public filterUrlRegexPatterns:RegExp[] = [new RegExp('/pincode/'), new RegExp('/templates/'), new RegExp('/shareable-link')];
  constructor(readonly sRenderer: StyleRenderer,
              private service: NgxHttpLoaderService){ }

}
